import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import { Card, CardContent, IconButton, InputBase } from "@mui/material";
import { GET_STORE_BY_SUPPLIER } from "../../config/cacheKey";
import { StoreBySupplier } from "../../models/branch.model";
import PhoneNumberBadge from "./phoneNumberBadge";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useHistory } from "react-router-dom";
import StorefrontIcon from "@mui/icons-material/Storefront";
import CloseIcon from "@mui/icons-material/Close";
import LanguageIcon from "@mui/icons-material/Language";
const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Item = styled(Paper)(() => ({
  backgroundColor: "#fff",
  textAlign: "center",
}));

export default function ModalStoreAndBranch({
  openModel,
  setOpenModal,
}: {
  openModel: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [open, setOpen] = React.useState(openModel);
  const [searchTerm, setSearchTerm] = React.useState("");
  const history = useHistory();
  const handleClose = () => {
    setOpen(false);
    setOpenModal(false);
  };

  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);

  const handleNavigate = (
    latitude: number,
    longitude: number,
    title: string
  ) => {
    const encodedTitle = encodeURIComponent(title);
    const url = `https://www.google.com/maps?q=${latitude},${longitude}&q=${encodedTitle}`;
    window.open(url, "_blank");
  };
  const rawData = localStorage.getItem(GET_STORE_BY_SUPPLIER);
  const storesAndBranches: StoreBySupplier[] = rawData
    ? JSON.parse(rawData)
    : [];
  // const storesAndBranches: StoreBySupplier[] = React.useMemo(() => {
  //   const rawData = localStorage.getItem(GET_STORE_BY_SUPPLIER);
  //   return rawData ? JSON.parse(rawData) : [];
  // }, [GET_STORE_BY_SUPPLIER]);

  const filteredStores = React.useMemo(() => {
    const lowerCaseSearchTerm = searchTerm.trim().toLowerCase();

    return storesAndBranches
      .map((store) => {
        const isStoreMatch = store.title
          .toLowerCase()
          .includes(lowerCaseSearchTerm);

        const filteredBranches = store.branches.filter((branch) =>
          branch.title.toLowerCase().includes(lowerCaseSearchTerm)
        );

        if (isStoreMatch) {
          return {
            ...store,
            branches: store.branches,
          };
        }

        if (filteredBranches.length > 0) {
          return {
            ...store,
            branches: filteredBranches,
          };
        }

        return null;
      })
      .filter((store) => store !== null);
  }, [searchTerm, storesAndBranches]);

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            borderRadius: "6px",
            height: "75vh",
            width: "70vw",
          }}
          className="ModalStoreAndBranch  "
        >
          <div style={{ textAlign: "left" }} onClick={handleClose}>
            <CloseIcon />
          </div>
          <Typography
            sx={{
              color: "#1D4A87",
              fontSize: "1.2rem",
              textAlign: "center",
              fontWeight: "bold",
              marginBottom: "45px",
            }}
          >
            فروشگاه‌ها و شعبه‌ها
          </Typography>
          {/* <PhoneNumberBadge /> */}
          <Paper
            elevation={0}
            style={{
              border: ".9px solid #DAE0E4",
              display: "flex",
              borderRadius: "3px",
              height: "35px",
              width: "20vw",
              marginRight: "10px",
              marginBottom: "15px",
            }}
            square={true}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                paddingX: "16px",
                height: "30px !important",
              }}
              placeholder="جستجو"
              onChange={handleSearchInput}
              value={searchTerm}
            />

            <IconButton
              type="button"
              sx={{ color: "#9AAFC4" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
          <div
            style={{ overflowY: "scroll", height: "75%", overflowX: "hidden" }}
          >
            {filteredStores?.map((store, index) => (
              <Grid container spacing={2} sx={{ padding: 1 }} key={index}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    marginTop: "10px !important",
                    marginBottom: "10px !important",
                  }}
                >
                  <Card>
                    <CardContent sx={{ paddingBottom: "12px !important" }}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid
                          item
                          xs={8}
                          sx={{ color: "#1D4A87", fontSize: "1.2rem" }}
                        >
                          {store?.logoBase64 ? (
                            <img
                              style={{ width: "10%", height: "20%" }}
                              className=" objectFit iconProfileBranchBorder"
                              src={`data:image/png;base64,${store?.logoBase64}`}
                              alt="طرح "
                            />
                          ) : (
                            <StorefrontIcon className=" colorDefaultFont marginLeft-15 iconProfileBranchBorder" />
                          )}
                          <b>{store?.title}</b>
                          <span>
                            {store?.isActive ? (
                              <b
                                style={{ color: "#01AF43", fontSize: ".8rem" }}
                              >
                                &nbsp;(فعال)&nbsp;
                              </b>
                            ) : (
                              <b
                                style={{ color: "#FB8C00", fontSize: ".8rem" }}
                              >
                                &nbsp;(غیرفعال)&nbsp;
                              </b>
                            )}
                          </span>
                        </Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                {store?.branches?.map((branch, branchIndex) => (
                  <Grid
                    item
                    xs={12}
                    key={branchIndex}
                    sx={{
                      paddingTop: "0 !important",
                      paddingBottom: "0 !important",
                    }}
                  >
                    <Card
                      sx={{
                        color: "#1D4A87",
                        background: "#F9FAFC  !important",
                      }}
                    >
                      <CardContent sx={{ paddingBottom: "12px !important" }}>
                        <Grid
                          container
                          spacing={1}
                          alignItems="center"
                          sx={{ color: "#1D4A87" }}
                        >
                          <Grid
                            item
                            xs={8}
                            onClick={() => {
                              if (branch?.url) {
                                window.open(branch?.url, "_blank");
                              }
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold" }}
                            >
                              {branch?.title}
                              {branch?.isActive ? (
                                <span
                                  style={{
                                    color: "#01AF43",
                                    fontSize: ".8rem",
                                  }}
                                >
                                  &nbsp;(فعال)&nbsp;
                                </span>
                              ) : (
                                <span
                                  style={{
                                    color: "#FB8C00",
                                    fontSize: ".8rem",
                                  }}
                                >
                                  &nbsp;(غیرفعال)&nbsp;
                                </span>
                              )}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "1rem" }}
                            >
                              {branch?.address}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "1rem", marginTop: ".5rem" }}
                            >
                              {branch.phoneNumbers.join(" - ")}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            container
                            justifyContent="flex-end"
                            spacing={1}
                            className="mainColor-100"
                          >
                            <Grid
                              item
                              onClick={() =>
                                handleNavigate(
                                  branch.lat,
                                  branch.lng,
                                  branch.title
                                )
                              }
                              className="cursorPointer"
                              sx={{ fontSize: ".9rem" }}
                            >
                              <b>
                                <LocationOnIcon />
                                نمایش در نقشه &nbsp; |
                              </b>
                            </Grid>

                            <Grid
                              item
                              onClick={() => {
                                if (branch?.isActive) {
                                  history.push({
                                    pathname: "/sale/customerInquiry",
                                    state: {
                                      branchId: branch.id,
                                    },
                                  });
                                  handleClose();
                                }
                              }}
                              className={
                                branch?.isActive ? "cursorPointer" : ""
                              }
                              sx={{
                                fontSize: ".9rem",
                                color: branch?.isActive ? "#2962FF" : "#9AAFC4",
                              }}
                            >
                              {branch.branchType === "Online" ? (
                                <b>
                                  <LanguageIcon
                                    onClick={() => {
                                      window.open(branch?.url, "_blank");
                                    }}
                                  />
                                  وب سایت
                                </b>
                              ) : (
                                <b>
                                  <AddCircleIcon /> ثبت فروش
                                </b>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ))}
          </div>
        </Box>
      </Modal>
    </div>
  );
}
